import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';

type Props = {
  isLogin?: boolean;
  positionRight?: boolean;
  width?: string;
};

const PopoverContainer = styled.div<Props>`
  padding: ${({ theme }) => rem(theme.space.default)};
  position: absolute;
  z-index: 9;
  top: 0;
  width: ${({ width }) => width || rem(328)};
  border-radius: ${rem(12)};
  background-color: ${({ theme }) => theme.color.gohan[100]};
  box-shadow: 0 ${rem(4)} ${rem(16)} 0 rgba(0, 0, 0, 0.15);
  max-height: calc(100vh - ${rem(100)});
  overflow: scroll;
  ${({ positionRight, isLogin }) =>
    positionRight ? 'left: 0;' : `right ${isLogin ? rem(80) : 0}`}
`;

export default PopoverContainer;
